export enum FileStatuses {
  uploading = 1,
  succeeded = 2,
  failed = 3
}
